module.exports = __webpack_public_path__ + "img/Banayeni.7ec4a0e8.png";